module.exports = __webpack_public_path__ + "img/scooterWhite.0505e711.svg";